module.exports = __webpack_public_path__ + "img/attach_money.c81af5a9.svg";